import React from "react";
import StoreSearchResult from "../types/StoreSearchResult";
import ProductTypeTag from "./ProductTypeTag";

interface SearchResultCardProps {
    storeSearchResult: StoreSearchResult;
}

const SearchResultCard: React.FC<SearchResultCardProps> = (props) => {

    const distanceInMiles = Math.round(props.storeSearchResult.distanceInMiles * 100) / 100;
    const distanceInKm = Math.round((props.storeSearchResult.distanceInMiles * 1.60934) * 100) / 100;

    return (
        <li className="blj-store-locator-results-list-store-card">
            <div className="blj-store-locator-results-list-store-card__distance">
                {`${distanceInMiles} mi.`}<br/>
                {`(${distanceInKm} km)`}
            </div>
            <div className="blj-store-locator-results-list-store-card__data">

                <div className="blj-store-locator-results-list-store-card__data-header">
                    <h3 className="blj-store-locator-results-list-store-card__title">
                        {props.storeSearchResult.store.storeName}
                    </h3>

                    <a className="blj-store-locator-results-list-store-card__address"
                       href={`https://www.google.com/maps/dir/?api=1&destination=${props.storeSearchResult.store.storeLocation.lat},${props.storeSearchResult.store.storeLocation.lng}`}
                       target="_blank"
                       rel="nofollow"
                    >
                        <address>
                            {props.storeSearchResult.store.storeLocation.address}<br/>
                        </address>
                    </a>

                    <a href={`tel:${props.storeSearchResult.store.storePhoneNumber}`}
                       className="blj-store-locator-results-list-store-card__phone"
                    >
                        {props.storeSearchResult.store.storePhoneNumber}
                    </a>
                </div>

                {props.storeSearchResult.store.storeProductTypes.length > 0 && (
                    <div className="blj-store-locator-results-list-store-card__tags">

                        {props.storeSearchResult.store.storeProductTypes.map((productType, index) => (
                            <ProductTypeTag
                                key={index}
                                tagText={productType.name}
                            />
                        ))}

                    </div>
                )}

            </div>
        </li>
    );

}

export default SearchResultCard;